
<f-flow fDraggable (fLoaded)="onLoaded()" (fCreateConnection)="onCreateConnection($event)">
  <f-canvas>
    <f-connection-for-create fBehavior="floating"></f-connection-for-create>
    @for (connection of connections; track connection.to) {
      <f-connection [fReassignDisabled]="true"
                    [fOutputId]="connection.from" [fInputId]="connection.to"
                    fBehavior="floating">
      </f-connection>
    }


    @for (stage of orderedApprovalFlowStages; track stage) {
      <div fNode fDragHandle [fNodePosition]="{ x: 50, y: ($index * 100) + 50 }">
        @if (!stage?.stageIsStarting) {
          <div fNodeInput fInputId="i_{{ stage?.stageName | concat }}" [fInputMultiple]="false" class="top"></div>
        }

        {{ stage?.stageName }}

        @if (stage?.stageIsStarting) {
          <span class="px-2 py-0.5 bg-green-50 text-green-500 border border-green-500 rounded-full text-xs">
            {{ 'first' | translate }}
          </span>
        }
        @else if (stage?.stageIsEnding) {
          <span class="px-2 py-0.5 bg-red-50 text-red-500 border border-red-500 rounded-full text-xs">
            {{ 'last' | translate }}
          </span>
        }

        @if (!stage?.stageIsEnding) {
          <div fNodeOutput fOutputId="o_{{ stage?.stageName | concat }}" class="bottom"></div>
        }
      </div>
      <!--      <div fNode fDragHandle [fNodePosition]="{ x: 0, y: 200 }">-->
        <!--        <div fNodeInput fInputId="3" [fInputMultiple]="false" class="top"></div>-->
        <!--        Connect to one input only-->
        <!--        <div fNodeOutput fOutputId="4" class="bottom"></div>-->
        <!--      </div>-->
    }
  </f-canvas>
</f-flow>
<!--<div class="examples-toolbar">-->
<!--  <button class="f-button" (click)="onDeleteConnections()">Delete Connections</button>-->
<!--</div>-->
